import * as React from "react";
import { Static } from "@bizform/type/decorator/Static.decorator";
import { ComponentElement, ComponentElementStatic } from "@bizform/type/model/component_element/ComponentElement.model";
import {
    ComponentElementManifest,
    ComponentElementProperty,
    LayoutCategory
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { PluginType } from "@bizform/type/model/model/Plugin.model";
import { ComponentElementClass, ReactComponentElementInit } from "@bizform/core/dist/js/bizflow/core.min";
import { DomAttribute } from "@bizform/type/model/dom/DomAttribute.model";
import { Debug } from "@bizform/helper/dist/js/bizflow/helper.min";
import { I18n } from "../../misc/model/I18n.model";


type Props = {
};

type State = {
    show: boolean;
    bgColor?: string;
};

/**
 * bfAutoFill 구현체,  ducking panel 이 차지하는 영역 이외의 모든 영역을 자동 차지하는 패널을 위한 레이아웃
 *
 * @since 0.0.1
 * @author Heungsoo,Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<null>>()
export class BfAutoFillPanel extends React.Component<Props, State> implements ComponentElement<null> {
    /**
     * implements ComponentElement
     */
    static readonly pluginType: string = PluginType.COMPONENTELEMENT;
    static readonly hidden: boolean = true;

    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_qauPpFNuk_PkfHKJPI0ukyJZsNClkz5",
        category: LayoutCategory.PANEL,
        label: I18n.layout.autoFillPanel.label,
        description: I18n.layout.autoFillPanel.description,
        icon: "fas fa-square-full",
        property: null
    };

    /** common state */
    destroyed: boolean;
    accessibility: boolean;
    elementId: string;
    applicationId: string;
    formId: string;
    parentDom: HTMLElement;

    /** action */
    onDisabled() {
        this._show();
    }
    onReadOnly() {
        this._show();
    }
    onPrint() {
        this._show();
    }
    onEdit() {
        this._show();
    }

    focus() {}
    setProperty(property: ComponentElementProperty) {
        try {
            this.setState({
                show: true,
                bgColor: property.attribute.bgColor.value
            });
        } catch (e) {
            Debug.console.error("setProperty", e);
        }
    }

    /** component element life cycle */
    @ReactComponentElementInit(BfAutoFillPanel)
    static init(): ComponentElement<null> {
        return;
    }

    initDone() {}
    destroy() {
        this.destroyDone();
    }
    destroyDone() {}

    /**
     *  React.Component
     */
    props: Props;
    state: State;

    constructor(props?: Props) {
        super(props);
        this.state = {
            show: false,
            bgColor: BfAutoFillPanel.componentElementManifest.property.attribute.bgColor.value
        };
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
        return this.state.show !== nextState.show || this.state.bgColor !== nextState.bgColor;
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Debug.console.error(error, errorInfo);
    }

    render() {
        if (!this.state.show) {
            return null;
        } else {
            const attr = {};
            attr[DomAttribute.AUTOFILL] = "";
            attr[DomAttribute.CONTAINER] = "";
            attr["style"] = {
                "visibility": "hidden"
            };
            if (this.state.bgColor) {
                attr["style"]["backgroundColor"] = this.state.bgColor;
            }
            return (
                <div
                    { ...attr }
                ></div>
            );
        }
    }

    private _show() {
        this.setState({
            show: true,
            bgColor: this.state.bgColor
        });
    }
}
